import { useI18n } from "@core/i18n/i18n";
import { colors } from "@ui/style/colors";
import { Button as PrimeButton, ButtonProps as PrimeButtonProps } from "primereact/button";
import { classNames } from "primereact/utils";
import React from "react";

type UiStyle = "primary" | "secondary" | "secondary_B" | "danger";

interface ButtonCustomProps {
	uiStyle?: UiStyle;
	children?: string;
}

export type ButtonProps = ButtonCustomProps & PrimeButtonProps;

export const Button = React.forwardRef<PrimeButton, ButtonProps>(
	({ uiStyle = "primary", children, className, ...props }, ref) => (
		<PrimeButton
			ref={ref}
			className={classNames(
				{ "p-button-secondary": uiStyle.startsWith("secondary") },
				{ "p-button-danger": uiStyle === "danger" },
				className,
			)}
			label={children}
			{...props}
			style={{
				...props.style,
				...(uiStyle === "secondary_B" && !props.disabled ? { backgroundColor: colors.white } : {}),
			}}
		/>
	),
);
Button.displayName = "Button";

export const RefreshButton = React.forwardRef<PrimeButton, ButtonProps>((props, ref) => {
	const { format } = useI18n();
	return <Button ref={ref} label={format("global.refreshButton")} icon="pi pi-refresh" iconPos="right" {...props} />;
});
RefreshButton.displayName = "RefreshButton";
